// Initialize slider for news-card sections that have the `news-card-slider` modifier
(function ($) {
  $(window).on("load", function () {
    var $section = $(".news-card.news-card-slider");
    $section.each(function () {
    //   var $section = $(this);
      var $list = $section.find(".wrapper");

      if (!$list.length) return;
      if ($list.hasClass("slick-initialized")) return;

       $list.slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: false,
         dots: true,
         speed: 600,
         infinite: true,
         swipe: true,
         adaptiveHeight: false,
         focusOnSelect: false,
         centerMode: true,
         centerPadding: '30%',
         responsive: [
          {
            breakpoint: 2400,
            settings: {
              centerPadding: '20%',
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1800,
            settings: {
              centerPadding: '10%',
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
           {
             breakpoint: 1025,
             settings: {
              centerPadding: '10%',
               slidesToShow: 1,
               slidesToScroll: 1,
             },
           },
           {
             breakpoint: 767,
             settings: {
              centerPadding: '10%',
               slidesToShow: 1,
               slidesToScroll: 1,
             },
           },
         ],
       });

       // Function to equalize slide heights
       function equalizeSlideHeights() {
         var maxHeight = 0;
         var $slides = $list.find('.slick-slide');
         
         // Reset heights to auto to get natural heights
         $slides.css('height', 'auto');
         
         // Find the tallest slide
         $slides.each(function() {
           var slideHeight = $(this).outerHeight();
           if (slideHeight > maxHeight) {
             maxHeight = slideHeight;
           }
         });
         
         // Set all slides to the same height
         if (maxHeight > 0) {
           $slides.css('height', maxHeight + 'px');
         }
       }

       // Add click functionality to exposed parts of adjacent slides and equalize heights
       $list.on('init afterChange setPosition', function(event, slick) {
         // Equalize slide heights
         equalizeSlideHeights();
         
         // Remove existing click handlers
         $list.find('.slick-slide').off('click.newsCardSlider');
         
         // Add click handlers to non-active slides
         $list.find('.slick-slide:not(.slick-current)').on('click.newsCardSlider', function(e) {
           e.preventDefault();
           e.stopPropagation();
           
           var slideIndex = $(this).data('slick-index');
           if (slideIndex !== undefined) {
             $list.slick('slickGoTo', slideIndex);
           }
         });
       });
    });
  });
})(jQuery);

// (function ($) {
//     $(document).ready(function () {
//       if ($(".news-card.news-card-slider").length > 0) {
//         // Add active class after a short delay
//         setTimeout(function () {
//           $(".news-card.news-card-slider").addClass("active");
  
//           // Initialize Slick slider if multiple quote items
//           if ($(".news-card.news-card-slider .item").length > 1) {
//             $(".news-card.news-card-slider .wrapper")
//               .slick({
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         arrows: false,
//         dots: false,
//         speed: 600,
//         infinite: true,
//         swipe: true,
//         adaptiveHeight: true,
//         focusOnSelect: false,
//         centerMode: true,
//         centerPadding: '30px',
//               })
//               .on("init", function (event, slick) {
//                 // Fade in the slider after initialization
//                 $(this).addClass("slick-ready");
//               });
//           } else {
//             // If only one slide, just show it without slick
//             $(".news-card.news-card-slider .wrapper").addClass("slick-ready");
//           }
//         }, 200);
//       }
//     });
//   })(jQuery);
  


